var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.75,
    cy: 9.5,
    r: 9.5,
    fill: "#F8BBD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 17.125V19M6.875 13.375H6.88125V13.3813H6.875V13.375ZM6.875 15.25H6.88125V15.2563H6.875V15.25ZM6.875 17.125H6.88125V17.1313H6.875V17.125ZM6.875 19H6.88125V19.0063H6.875V19ZM8.9563 13.375H8.96255V13.3813H8.9563V13.375ZM8.9563 15.25H8.96255V15.2563H8.9563V15.25ZM8.9563 17.125H8.96255V17.1313H8.9563V17.125ZM8.9563 19H8.96255V19.0063H8.9563V19ZM11.0437 13.375H11.05V13.3813H11.0437V13.375ZM11.0437 15.25H11.05V15.2563H11.0437V15.25ZM11.0437 17.125H11.05V17.1313H11.0437V17.125ZM11.0437 19H11.05V19.0063H11.0437V19ZM13.125 13.375H13.1313V13.3813H13.125V13.375ZM13.125 15.25H13.1313V15.2563H13.125V15.25ZM6.875 9H13.125V10.875H6.875V9ZM10 5.875C8.42333 5.875 6.86797 5.96622 5.3389 6.14367C4.42173 6.25011 3.75 7.04083 3.75 7.96416V20.25C3.75 21.2855 4.58947 22.125 5.625 22.125H14.375C15.4105 22.125 16.25 21.2855 16.25 20.25V7.96416C16.25 7.04083 15.5783 6.25011 14.6611 6.14367C13.132 5.96622 11.5767 5.875 10 5.875Z",
    stroke: "#C2185B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculationIcon);
export default __webpack_public_path__ + "static/media/calculation_icon.5d6f3e0bfdcb6f1c9573ddc9b2454ff9.svg";
export { ForwardRef as ReactComponent };